export default {
    createJob: 'สร้างงาน',
    updateJob: 'แก้ไขงาน',
    jobName: 'ชื่องาน',
    save: 'บันทึก',
    thisFieldIsRequired: 'กรุณากรอกข้อมูล',
    thisFieldIsExceededCharacters: 'ข้อความเกิน 255 ตัวอักษร',
    congratulation: 'ยินดีด้วย',
    errorMessage: 'เกิดข้อผิดพลาด',
    jobIsCreated: 'งานถูกสร้างแล้ว',
    jobIsUpdated: 'งานถูกอัปเดตแล้ว'
}
